import { NavLink as Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaBars } from 'react-icons/fa';

export const Nav = styled.nav`
  background: #000000;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #ffffff;
  padding: 0 20px;
  box-sizing: border-box;
  /* Add a box shadow for better visibility */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* Make the navbar sticky */
  /* This will keep the navbar at the top of the viewport when scrolling */
  background-color: #000000;
  /* Ensure the navbar is always on top */
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const NavLogo = styled(Link)`
  justify-self: flex-start;
  cursor: pointer;
  display: flex;
  align-items: center;
  /* ce margin c'est le coté du logo si on veux le remettre */
  /* margin-left: 2px; */

  & > img {
    border-radius: 50%; /* Makes the image circular */
    border: 2px solid #ffffff; /* Adds a 2px white border */
    object-fit: cover; /* Prevents the image from stretching */
    box-sizing: border-box; /* Includes border in the element's total width and height */
  }
`;
export const Bars = styled(FaBars)`
  display: none;
  color: #ffffff;

  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 75%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

export const NavMenu = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 768px) {
    display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
    flex-direction: column;
    width: 100%;
    /* height: 90vh; */
    position: absolute;
    top: 80px;
    left: 0;
    background: #000000;
    transition: all 0.2s ease-in-out;
  }
`;

export const NavLink = styled(Link)`
  color: #ffffff;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1.5rem;
  /* height: 100%; */
  cursor: pointer;
  box-sizing: border-box;
  border-bottom: 3px solid transparent;

  &.active {
    color: #ffffff;
    font-weight: bold;
    border-bottom: 3px solid #ffffff;
  }

  &:hover {
    color: #cccccc;
    transition: all 0.2s ease-in-out;
  }

  @media screen and (max-width: 768px) {
    padding: 1.5rem;
    width: 100%;
    justify-content: center;
    border-bottom: none;
  }
`;
